module.exports = __webpack_public_path__ + "img/icon-list-more.ffd17144.svg";